import axios from "axios";
import { HttpClient, RequestParams } from "../../utils/api/http-client";
import { ITrademarkManagerQuery } from "../../models/trademark-manager/query";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import { ITrademarkManager } from "../../models/trademark-manager/response";
import {
  ICreateTradmarkManager,
  IExportTradeManagerExcel,
  IUpdateTradmarkManager,
} from "../../models/trademark-manager/request";
import { ACCESS_TOKEN, LANGUAGE_CODE } from "../../utils/helpers/constants";

class TrademarkManagerService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  getAllTrademarkManagers = (query: ITrademarkManagerQuery, params?: RequestParams) =>
    this.http.request<IBaseListingResponse<ITrademarkManager>>({
      path: `/trademark-manager`,
      method: "GET",
      query,
      ...params,
    });

  getTrademarkManager = (id: number, params?: RequestParams) =>
    this.http.request<ITrademarkManager>({
      path: `/trademark-manager/${id}`,
      method: "GET",
      ...params,
    });

  createTrademarkManager = (data: ICreateTradmarkManager, params?: RequestParams) =>
    this.http.request<ITrademarkManager>({
      path: "/trademark-manager",
      method: "POST",
      body: data,
      ...params,
    });

  updateTrademarkManager = (id: number, data: IUpdateTradmarkManager, params?: RequestParams) =>
    this.http.request<ITrademarkManager>({
      path: `/trademark-manager/${id}`,
      method: "PUT",
      body: data,
      ...params,
    });

  deleteTrademarkManager = (id: number, params?: RequestParams) =>
    this.http.request<ITrademarkManager>({
      path: `/trademark-manager/${id}`,
      method: "DELETE",
      ...params,
    });

  exportExcel = (data: IExportTradeManagerExcel, query: ITrademarkManagerQuery) =>
    axios.post(
      ` ${process.env.REACT_APP_BASE_API_URL}/trademark-manager/export`,
      data,
      {
        headers: {
          authorization: `Bearer ${
            localStorage.getItem(ACCESS_TOKEN) ||
            sessionStorage.getItem(ACCESS_TOKEN)
          }`,
          "Content-Type": "application/json",
          "accept-language": `${
            localStorage.getItem(LANGUAGE_CODE) ??
            process.env.REACT_APP_DEFAULT_LANGUAGE
          }`,
        },
        params: query,
        responseType: "arraybuffer",
      }
    );
}

export default TrademarkManagerService;
